import './styles.scss';

import React, {ButtonHTMLAttributes, MouseEventHandler, ReactNode} from 'react';

import { addStateHistory } from '../../../utils/StateHistoryUtil';
import {AppSpinner} from '../AppSpinner/AppSpinner';

export enum AppButtonMode {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TRANSPARENT = 'transparent',
    TERTIARY = 'tertiary',
    BLUE = 'blue',
    ORANGE = 'orange',
    DARK_BLUE = 'dark-blue',
}

export enum AppButtonSize {
    DEFAULT = '',
    SMALL = 'small',
}

interface AppButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    mode?: AppButtonMode;
    size?: AppButtonSize;
    loading?: boolean;
    loadingText?: string;
    additionalClass?: string;
    Icon?: ReactNode;
    action: string;
    onClick?:  MouseEventHandler<HTMLButtonElement> | undefined;
}

export const AppButton = ({
    mode = AppButtonMode.PRIMARY,
    size = AppButtonSize.DEFAULT,
    loading = false,
    loadingText = '',
    additionalClass = '',
    children,
    Icon,
    action,
    ...rest
}: AppButtonProps) => {

    const trackClick: MouseEventHandler<HTMLButtonElement> = () => {
        addStateHistory(`${action}-click`);
    }

    return (
        <button onClick={trackClick} {...rest} className={`app-button ${mode} ${size} ${loading ? 'loading' : ''} ${additionalClass}`}>
            {loading ? <AppSpinner text={loadingText} /> : children}
            {Icon && !loading && <div className='app-button__icon'>{Icon}</div>}
        </button>
    );

};
